/* eslint-disable no-console */
import React from 'react';
import styled from 'styled-components';
import * as Sentry from '@sentry/react';
import Button from '../bits/Button.jsx';

const StyledErrorPanel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 40px;
`;

class ErrorBoundaryMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Fatal exception thrown during screen render');
    console.error(errorInfo);

    Sentry.captureException(error, {
      tags: {
        errorCategory: 'screen-render-error',
      },
    });
  }

  reload = () => {
    window.location = '/dashboard';
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <StyledErrorPanel>
          <h1 className="title">Ooops, something went wrong.</h1>
          <Button color="primary" onClick={this.reload}>Reload</Button>
        </StyledErrorPanel>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryMain;
